<template>
	<div class="b-sim-history-card" :class="classes">
		<div class="b-sim-history-card__description">
			{{ $t("Histórico de simulações") }}
		</div>

		<div class="b-sim-history-card__items">
			<div
				v-for="item in items"
				:key="item.id"
				class="b-sim-history-card__item"
			>
				<div class="b-sim-history-card__itemDate">
					{{ formatDate(item.date) }}
				</div>
				<div class="b-sim-history-card__itemBody">
					<div class="b-sim-history-card__itemTitle">{{ item.title }}</div>
					<div class="b-sim-history-card__itemControls">
						<!-- <BBtn
							variant="text"
							size="s"
							shape="circle"
							@click="() => handleDownloadClick(item)"
						>
							<BIcon name="Download" size="16px" />
						</BBtn> -->

						<BBtn
							variant="text"
							size="s"
							shape="circle"
							@click="() => handleEditClick(item)"
						>
							<BIcon name="Edit" size="16px" />
						</BBtn>

						<BBtn
							variant="text"
							size="s"
							shape="circle"
							@click="() => handleDuplicateClick(item)"
						>
							<BIcon name="Duplicate" size="16px" />
						</BBtn>

						<BBtn
							variant="text"
							size="s"
							shape="circle"
							@click="() => handleDeleteClick(item)"
						>
							<BIcon name="Delete" size="16px" />
						</BBtn>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { formatDate } from "@/utils";
import { mapActions } from "vuex";

import BIcon from "@/components/base/BIcon";
import BBtn from "@/components/base/BBtn";

export default {
	components: {
		BIcon,
		BBtn,
	},
	props: {
		items: {
			type: Array,
			default: () => [],
		},
	},
	computed: {
		classes() {
			return [];
		},
	},
	methods: {
		...mapActions("simulations", ["duplicateSimulation", "deleteSimulation"]),

		handleEditClick({ id }) {
			this.$router.push({
				name: "Simulator",
				params: {
					simulation: id,
				},
			});
		},

		handleDuplicateClick({ id }) {
			this.duplicateSimulation({ id })
				.then(({ id }) => {
					this.$router.push({
						name: "Simulator",
						params: {
							simulation: id,
						},
					});
				})
				.catch((err) => {});
		},
		handleDeleteClick({ id }) {
			this.deleteSimulation({ id }).catch((err) => {});
		},

		formatDate,
	},
};
</script>
<style lang="scss">
.b-sim-history-card {
	--padding-card: 20px;
	border-radius: 16px;
	width: 100%;
	padding: var(--padding-card);
	background: var(--color-neutral-0);
	cursor: pointer;
	display: flex;
	flex-direction: column;
	align-items: stretch;
}

.b-sim-history-card__description {
	text-transform: uppercase;
	color: var(--color-primary-200);
	font-size: var(--font-size-2xs);
	font-weight: var(--font-weight-bold);
	letter-spacing: 2px;
	margin-bottom: 32px;
}

.b-sim-history-card__description {
	color: var(--color-neutral-400);
}

.b-sim-history-card__items {
	overflow: auto;
	margin-inline: calc(-1 * var(--padding-card));
	padding-inline: var(--padding-card);
	margin-bottom: calc(-1 * var(--padding-card));
	padding-bottom: var(--padding-card);
}

.b-sim-history-card__item {
	padding-bottom: 10px;
	padding-top: 15px;

	&:not(:last-child) {
		border-block-end: 1px solid var(--color-neutral-100);
	}
}

.b-sim-history-card__itemDate {
	color: var(--color-neutral-300);
	font-size: var(--font-size-3xs);
}

.b-sim-history-card__itemBody {
	position: relative;
	display: flex;
	justify-content: space-between;
	align-items: center;
	gap: 24px;
}

.b-sim-history-card__itemTitle {
	color: var(--color-neutral-900);
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

.b-sim-history-card__itemControls {
	position: absolute;
	right: 0;
	opacity: 0;
	visibility: hidden;
	display: flex;
	align-items: center;
	gap: 4px;
	background-color: #fff;
	box-shadow: -8px 0 8px white;
	transition: 0.12s;
	transform: translateX(10%);
}

.b-sim-history-card__item:hover {
	.b-sim-history-card__itemControls {
		opacity: 1;
		visibility: visible;
		transform: translateX(0%);
	}
}
</style>
